import { css } from '@emotion/react';

const keyValuePairTableStyles = css`
    color: var(--primary-text-color);
    .list-item {
        display: flex;
        break-inside: avoid;
    }

    .list-item:not(:last-child) {
        border-bottom: 1px solid #bababa;
    }

    .list-key {
        width: 40%;
    }

    .list-value {
        width: 60%;
    }
`;

export const themekeyValuePairTableStyles = css`
    color: var(--default-text-color);
    ul {
        padding: var(--listComponent-listPadding);
    }

    .list-item {
        display: flex;
        break-inside: avoid;
        border-style: var(--listComponent-listItemBorderStyle);
        border-color: var(--listComponent-listItemBorderColor);
        border-width: var(--listComponent-listItemBorderWidth);
        font-family: var(--listComponent-listItemFontFamily);
        color: var(--listComponent-listItemTextColor);
        font-weight: var(--listComponent-listItemFontWeight);
        font-size: var(--listComponent-listItemFontSize);
        line-height: var(--listComponent-listItemLineHeight);
        padding: var(--listComponent-listItemPadding);
    }

    .list-item:nth-child(even) {
        background-color: var(--listComponent-alternateListItemsBgColor);
    }

    .list-key {
        width: 40%;
        font-weight: var(--listComponent-listKeyFontWeight);
        font-family: var(--listComponent-listKeyFontFamily);
        color: var(--listComponent-listKeyTextColor);
        font-size: var(--listComponent-listKeyFontSize);
    }

    .list-value {
        width: 60%;
        font-weight: var(--listComponent-listValueFontWeight);
        font-family: var(--listComponent-listValueFontFamily);
        color: var(--listComponent-listValueTextColor);
        font-size: var(--listComponent-listValueFontSize);
    }
`;

export default keyValuePairTableStyles;
